<script>
    import {fade} from 'svelte/transition';
    let scrol = 0;
    let temp = 0;
    $: innerWidth = 2000;
    export let slidesMob;
    let currentAnim = 'start';
    let cur = 0;
    const clamp = (number, min, max) => Math.min(Math.max(number, min), max);
    /**
     *
     * @param {object}e
     */
    function prev(e) {
        cur = clamp(--cur, 0, slidesMob.length - 1);

        if (cur === 0) {
            currentAnim = 'start';
        } else if (currentAnim === 'nextSlide') {
            currentAnim = 'slidePrev';
        } else if (currentAnim === 'slidePrev' || cur > 0) {
            currentAnim = 'nextSlide';
        }
    }
    /**
     *
     * @param {object}e
     */
    function next(e) {
        if (cur === slidesMob.length - 1) {
            cur = 0;
        } else {
            cur = clamp(++cur, 0, slidesMob.length - 1);
        }

        if (cur === 0) {
            currentAnim = 'start';
        } else if (currentAnim === 'nextSlide') {
            currentAnim = 'slidePrev';
        } else if (currentAnim === 'slidePrev' || cur > 0) {
            currentAnim = 'nextSlide';
        }
    }
    const ARROW_LEFT = 37;
    const ARROW_RIGHT = 39;
    /**
     *
     * @param {object}e
     */
    function handleShortcut(e) {
        if (e.keyCode === ARROW_LEFT) {
            prev();
        }
        if (e.keyCode === ARROW_RIGHT) {
            next();
        }
    }
</script>

<svelte:window on:keyup={handleShortcut} />

<div class="inner-wrapper" >

    <div class="slide-background" >
        <div class="slide" bind:this={scrol}
            on:scroll={() => {
                temp = scrol.scrollLeft;
                console.log('this is scrol '+scrol.scrollLeft);
            }}>
            {#each slidesMob as slide, id}
                <div class="main_div" transition:fade={{duration: 200}}>
                    <div class="outer_div {currentAnim}">
                        <div class="slide-inner">
                            <div class="img-slider">
                                <img src={slide.mobile_image} alt="" />
                            </div>
                            <div class="content-slider">
                                <div class="content-slideno">
                                    <p style="padding:0;">{id + 1}</p>
                                </div>
                                <div class="head-slider">
                                    {#if slide.heading === 'VcX'}
                                        <p style="margin-left:-6vw">
                                            {@html slide.heading}
                                        </p>
                                    {:else}
                                        <p>{@html slide.heading}</p>
                                    {/if}
                                </div>
                                <hr class="new4" />
                                <div class="time-slider">
                                    {#if slide.time != ''}
                                        <ul>
                                            <li>{slide.time}</li>
                                        </ul>
                                    {/if}
                                </div>
                                <div class="text-slider">
                                    <p>{@html slide.content}</p>
                                </div>
                                <div>
                                    <button
                                        class="learn-button"
                                        on:click={()=>location.href=(slide.link)}
                                    >
                                        Learn More
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            {/each}
        </div>
    </div>

    {#if slidesMob.length === 1}
        <div style="margin-top:7.009vw; display:flex; margin-left: 47.664vw;">
            <div style="background-color:rgba(247, 224, 95, 1)"class="page-circle" />
        </div>
    {:else if slidesMob.length === 2}
        <div style="margin-top:7.009vw; display:flex; margin-left: 47.664vw;">
                {#if temp >= 0 && temp < 250}
                <div style="background-color:rgba(247, 224, 95, 1); "class="page-circle" />
                <div style="margin-left:2.276vw;" class="page-circle" />
                {:else if temp > 250}
                <div class="page-circle" />
                <div style="background-color:rgba(247, 224, 95, 1); margin-left:2.276vw;" class="page-circle" />
                {/if}
        </div>
    {:else if slidesMob.length === 3}
        <div style="margin-top:7.009vw; display:flex; margin-left: 41.664vw;">
            {#if temp >= 0 && temp < 250}
                <div style="background-color:rgba(247, 224, 95, 1);  margin-left:2.276vw;"class="page-circle" />
                <div style="margin-left:2.276vw;" class="page-circle" />
                <div class="page-circle" style="margin-left:2.276vw;" />
            {:else if temp > 250 && temp < 500}
                <div style="margin-left:2.276vw;"  class="page-circle" />
                <div style="background-color:rgba(247, 224, 95, 1); margin-left:2.276vw;" class="page-circle" />
                <div style="margin-left:2.276vw;" class="page-circle" />
            {:else if temp > 500}
                <div style="margin-left:2.276vw;" class="page-circle" />
                <div style="margin-left:2.276vw;" class="page-circle" />
                <div style="background-color:rgba(247, 224, 95, 1); margin-left:2.276vw;" class="page-circle" />
            {/if}
        </div>

    {/if}
    
</div>

<style>
    .page-circle {
        width: 2.729vw;
        height: 2.729vw;
        border-radius: 50%;
        background-color: rgba(239, 248, 255, 1);
    }
    .outer-wrapper {
        width: 100%;
        padding: 0;
        position: none;
    }
    .inner-wrapper {
        position: absolute;
        z-index: 0;
        overflow: hidden;
        padding-top: 16.355vw;
        height: 175vw;
        width: 100%;
        background-color: white;
    }
    .slide-background {
        flex: 1 0 auto;
        align-items: center;
        text-align: center;
        border-left: none;
        background: conic-gradient(from 90deg at -100% 17%, #eff8ff, white);
        margin-left: 0;
        border-radius: 0;
    }
    .slide {
        display: flex;
        gap: 12vw;
        overflow-x: scroll;
    }
    .slide::-webkit-scrollbar {
        display: none;
    }
    .main_div {
        transition: transform 5s, opacity 2s;
    }
    .main_div .start {
        transition-duration: 0.5s;
        opacity: 1;
        transform: translate(14vw);
    }
    .main_div .nextSlide {
        transform: translate(-90vw);
        transition-duration: 0.5s;
        opacity: 1;
    }
    .main_div .slidePrev {
        transform: translate(-192vw);
        transition-duration: 0.5s;
        opacity: 1;
    }
    .slide-inner {
        justify-content: unset;
        margin: auto;
        flex: 1 0 auto;
        width: 96%;
        height: 80%;
        align-items: unset;
        display: flex;
        text-align: unset;
        font-weight: bold;
        color: black;
        gap: 5.374vw;
        flex-direction: column;
    }
    .img-slider {
        width: 57.71vw;
        height: 39.019vw;
        margin-top: 1.645vw;
        margin-left: 5vw;
    }
    .img-slider img {
        width: 100%;
        height: 100%;
        border-radius: 4.673vw;
    }
    .content-slider {
        height: 89.15vw;
        width: 130%;
        margin-right: 6vw;
        z-index: 0;
        margin-left: -16vw;
    }
    .content-slideno {
        margin-left: 13.318vw;
        z-index: 1;
        background-color: #f7e05f;
        width: 5.152vw;
        height: 5.607vw;
        margin-top: 0;
        padding-top: 0;
        border-radius: 0vw 0vw 4.08vw 0.521vw;
    }
    .content-slideno p {
        font-size: 2.804vw;
        padding-left: 0;
        text-align: center;
    }
    .head-slider {
        width: 55.14vw;
        height: 11.215vw;
        text-align: center;
        margin-left: 25.234vw;
        padding-top: 0;
        margin-top: -7vw;
        color: rgba(0, 32, 75, 1);
    }
    .head-slider p {
        font-size: 4.673vw;
        font-weight: 600;
        margin-bottom: 0;
        width: 56vw;
    }
    hr.new4 {
        color: #00204b;
        border: 0.117vw solid;
        margin-bottom: 0;
        opacity: 1;
        width: 78.741vw;
        margin: 4.673vw auto;
    }
    .time-slider {
        height: 3.972vw;
        width: fit-content;
        margin-top: 9.346vw;
        margin-left: 36.682vw;
        margin-right: 0;
    }
    .time-slider ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .time-slider ul li::before {
        content: "\2022";
        color: #7cc1ff;
        font-weight: bold;
        display: inline-block;
        width: 1.5vw;
        margin: 0;
        padding-right: 3.5vw;
        font-size: 4vw;
    }
    .time-slider ul li {
        font-style: normal;
        font-weight: 400;
        font-size: 3.271vw;
        margin: 0;
        padding: 0;
    }
    .text-slider {
        width: 77.804vw;
        height: 35.748vw;
        margin-top: 9.813vw;
        margin-left: 12.383vw;
        color: rgba(0, 32, 75, 1);
    }
    .text-slider p {
        font-weight: 400;
        font-size: 2.804vw;
        text-align: center;
    }
    .learn-button {
        margin: auto;
        background-color: #3c74c0;
        color: white;
        border-radius: 12.617vw;
        border: none;
        width: 27.804vw;
        height: 8.178vw;
        font-size: 2.804vw;
    }
</style>
